import {BuyFeatureType} from '@gongxigames/framework/slot/services/logic/buyFeature/BuyFeatureLogicWrapper';

export interface IBuyFeatureLogic<BuyFeatureT = BuyFeatureType> {
    getType(): BuyFeatureT;
    isInProgress(type: BuyFeatureT): boolean;
    getMultiplier(): number;
    getPrice(bet: number): number;
    getIndependentBet(bet: number): number;
    setProgressStarted(): void;
    get isProgressStarted(): boolean;
    set isProgressStarted(value: boolean);
    get isRequest(): boolean;
    set isRequest(value: boolean);
    getBuyFeatureOrUsualBonus(bonusId: number): number;
    getBuyFeatureOrUsualAction(action: number): number;
    isBuyFeatureGame(): boolean;
    isAction(action: number): boolean;
    getAction(): number;
    shouldHide(): boolean;
    isMinBetAboveBuyFeatureLimit(): boolean;
    get isIndependentBet(): boolean;
    set isIndependentBet(value: boolean);
}
